import { Trans } from 'react-i18next'

import anatomySensePNG from '~/assets/images/anatomy/anatomy-sense.png'
import anatomySenseWEBP from '~/assets/images/anatomy/anatomy-sense.webp'
import { InfoPageStyles as S } from '~/pages/anatomy/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const AnatomySense = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Anatomy that actually makes sense',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={anatomySenseWEBP} type="image/webp" />
            <img src={anatomySensePNG} alt="Anatomy Sense" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="anatomy" i18nKey="onboarding.anatomySense.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="anatomy" i18nKey="onboarding.anatomySense.subtitle" />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default AnatomySense
